/*
    User.js - User model
 */

import {Rest} from '@/paks/vu-app'

export default new Rest(
    'User',
    {
        checkSession: {method: 'POST', uri: '/public/:controller/checkSession'},
        authenticate: {method: 'POST', uri: '/public/:controller/authenticate'},

        login: {method: 'POST', uri: '/:controller/login'},
        logout: {method: 'POST', uri: '/:controller/logout'},
        
        updateRole: {method: 'POST', uri: '/:controller/updateRole'},
    },
)
